import { applyFieldLogic } from './apply-field-logic';
import { buildBannerType } from './build-banner-type';
import { cleanFormData } from './clean-form-data';
import { getDynamicOptions } from './get-dynamic-options';

export const getPlayerVsPlayerHelpers = () => ({
  buildBannerType,
  getDynamicOptions,
  cleanFormData,
  applyFieldLogic
});

export { buildBannerType, getDynamicOptions, cleanFormData, applyFieldLogic };
